module.exports = {
	"SYSTEM_DISABLE": "105"
}